export default __webpack_public_path__ + "static/media/icon-StoneShapeRound.bed1d15d.png";